module.exports = __webpack_public_path__ + "static/media/video1.7bab5831.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/app/features/assets/video1.mp4
// module id = 111
// module chunks = 0